import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const Banner = styled.section`
  background-color: var(--dark-blue);
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 780px) {
    display: none;
  }
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  text-transform: uppercase;

  h2 {
    max-width: 10em;
    font-size: 28px;
    margin-top: 0.5em;
    color: white;
    line-height: 1.2;
  }
`;

export const BannerHeadlineMain = styled.span`
  display: block;
  font-weight: 900;
  color: var(--carrot-orange);
`;

export const BannerHeadlineSub = styled.span`
  display: block;
  font-weight: 400;
  color: var(--carrot-orange);
`;

export const RocketContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75em;
  border-radius: 100%;
`;

export const RocketDisplay = styled(FontAwesomeIcon)`
  color: white;
  font-size: 3em;
  color: var(--carrot-orange);
`;
